import '../node_modules/bootstrap/scss/bootstrap.scss' 

import React, { useState, useEffect, useRef } from 'react';

// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import productosOld from './img/productos2.gif'
import digital from './img/digital.gif'
import sostenibilidad from './img/sostenibilidad.png'
import especiales from './img/especiales.jpg'

import intro from './img/intro.mp4'
import './App.css';

import { Link } from "react-router-dom";

import Velocity from 'velocity-animate';

function App() {

  const introVideo = useRef();

  // useEffect( () => {
  //   introVideo.current.onended = () => {
  //     document.querySelector('.app-row').style.opacity = 1;
  //     Velocity(document.querySelector('.video-intro'), {opacity: 0, zIndex: -1}, {duration:500});
  //   }
  //   introVideo.current.play();
  // }, []);

  const showIntro = () => {

  }

  return (
    <div className="App container-fluid g-0">

{/*      <div className="video-intro">
       <video ref={introVideo} muted>
        <source src={intro} type="video/mp4"/>
      </video>
      </div> */}

      <div className="row g-0 app-row">

        <div className="col-6 d-flex align-items-center flex-column justify-center halfvh halfwidth">
          <img src={productos} className="bg-gif" />
          <div className="halfwidth-overlay">
            <Link to="/productos" relative="path">
              <span className="halfwidth-button">PRODUCTOS <span className="chevron">></span></span>
            </Link>
          </div>
        </div> 

        <div className="col-6 d-flex align-items-center flex-column justify-center halfvh halfwidth">
          <img src={digital} className="bg-gif" />
          <div className="halfwidth-overlay">
            <Link to="/digital" relative="path">
              <span className="halfwidth-button">DIGITALES <span className="chevron">></span></span>
            </Link>
          </div>          
        </div>

        <div className="col-6 d-flex align-items-center flex-column justify-center halfvh halfwidth">
          <img src={especiales} className="bg-gif" />
          <div className="halfwidth-overlay">
            <Link to="/especiales" relative="path">
              <span className="halfwidth-button-2">PROYECTOS ESPECIALES <span className="chevron">></span></span>
            </Link>
          </div>          
        </div>

        <div className="col-6 d-flex align-items-center flex-column justify-center halfvh halfwidth">
          <img src={sostenibilidad} className="bg-gif" />
          <div className="halfwidth-overlay">
            <Link to="/sostenibilidad" relative="path">
              <span className="halfwidth-button">SOSTENIBILIDAD <span className="chevron">></span></span>
            </Link>
          </div>
        </div>        

      </div>

    </div>
  );
}

export default App;
